module.exports = __webpack_public_path__ + "img/zhiyin.74266bef.png";